<template lang="pug">
	section.container-fluid.animated.fadeIn.pt-3
		div(v-if="event.data.users_can_see_dashboard.includes(account.data.id)")
			h2.mt-4.mb-3.g-between-center
				| Стойка регистрации
				b-button(variant="primary" :to="`/events-conferences/${$route.params.id}/delivery-dashboard/`" target="_blank") Дашборд
			b-tabs
				b-tab(active)
					template(v-slot:title)
						| Все гости
						b-badge.ml-2(variant="primary" v-if="ppntsAttendedNot.length") {{ ppntsAttendedNot.length }}
					firstStand
				b-tab
					template(v-slot:title)
						| Пришли
						b-badge.ml-2(variant="primary" v-if="ppntsAttended.length") {{ ppntsAttended.length }}
					secondStand
				b-tab
					template(v-slot:title)
						| Выдано
						b-badge.ml-2(variant="primary" v-if="ppntsComplete.length") {{ ppntsComplete.length }}
					thirdStand
		div(v-else)
			| У вас нет доступа на просмотр этой страницы
</template>

<script>
	import firstStand from './tabs/firstStand'
	import secondStand from './tabs/secondStand'
	import thirdStand from './tabs/thirdStand'
	import {mapState} from "vuex";
	import store from '../../store/index'

	export default {
		name: 'DeliveryEvent',
		components: {
			firstStand,
			secondStand,
			thirdStand,
		},
		data: () => ({
			interval: null,
			fields:['id','user','dependent_member','reception_letter','reception_number','stage','attended','incomplete','delivered','delivered_datetime','denied']
		}),
		computed: {
			...mapState(['account','event']),
			...mapState({
				participants: state => state.event.participants,
			}),
			ppntsList(){ return (this.participants.data || []) },
			ppntsAttendedNot(){ return this.ppntsList.filter(({attended,denied})=>!attended && !denied) },
			ppntsAttended(){
				return this.ppntsList.filter(({attended,incomplete,delivered})=>attended && !incomplete && !delivered)
			},
			ppntsComplete(){
				return this.ppntsList.filter(({attended, incomplete, delivered})=>(attended && (incomplete || delivered)))
			},
		},
		methods: {
			refreshPpnts(){ this.$store.dispatch('getEventParticipants',{id:this.$route.params.id,params:{fields:this.fields}}) },
		},
		beforeRouteEnter(to,from,next){
			store.dispatch('getEvent',{id:to.params.id}).then(()=> next() );
		},
		beforeMount(){
			if (this.event.data.users_can_see_dashboard.includes(this.account.data.id)){
				this.refreshPpnts();
				this.interval = setInterval(()=>this.refreshPpnts(),5000)
			}
		},
		destroyed(){
			clearInterval(this.interval);
		}
	}
</script>

